export type BrandType = 'flow888' | 'nova7' | 'gg888' | 'crackerjackpot';

export const BRAND_COLORS: Record<BrandType, string> = {
  flow888: '#313485',
  nova7: '#892bd4',
  gg888: '#001889',
  // crackerjackpot shares the same color scheme as gg888
  crackerjackpot: '#001889',
};

export const BRAND_SITE_URLS: Record<BrandType, string> = {
  flow888: 'https://flow888.win',
  nova7: 'https://nova7.co',
  gg888: 'https://gg888.co',
  crackerjackpot: 'https://crackerjackpot.co',
};

export function getBrandSiteUrl(): string {
  return BRAND_SITE_URLS[getDomainBrand()];
}

export function getDomainBrand(): BrandType {
  const hostname = window.location.hostname;
  
  if (hostname.includes('nova7')) {
    return 'nova7';
  }

  if (hostname.includes('gg888')) {
    return 'gg888';
  }

  if (hostname.includes('crackerjackpot')) {
    return 'crackerjackpot';
  }

  // Default to flow888 (includes flow888.win and localhost)
  return 'flow888';
}

export function getBrandColor(): string {
  return BRAND_COLORS[getDomainBrand()];
}

export function applyBrandTheme(): void {
  const brand = getDomainBrand();
  const primaryColor = BRAND_COLORS[brand];
  document.documentElement.style.setProperty('--primary-color', primaryColor);
}

export function isFlow888(): boolean {
  return getDomainBrand() === 'flow888';
}

export function isNova7(): boolean {
  return getDomainBrand() === 'nova7';
}

export function isGG888(): boolean {
  return getDomainBrand() === 'gg888';
}

export function isCrackerjackpot(): boolean {
  return getDomainBrand() === 'crackerjackpot';
}
